// extracted by mini-css-extract-plugin
export default {"iconContainer":"orderSummary_iconContainer__0tw5K","fullView":"orderSummary_fullView__kgWWt","shimmer":"orderSummary_shimmer__NERT1"};